import {createSlice} from '@reduxjs/toolkit';

import {getServerTimeZoneConfigSuccess} from 'src/openapi/admin/apis/ClientConfigApi';

import type {AppState} from 'src/store/typedef';

interface InitialState {
    timeZone: string
}

const initialState: InitialState = {
    timeZone: 'UTC',
};

export const serverTimeZoneSlice = createSlice({
    name: 'serverTimeZone',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getServerTimeZoneConfigSuccess, (state, action) => {
                state.timeZone = action.payload.data.serverTimeZone;
            });
    }
});
export const selectServerTimeZone = (state: AppState) => state.config.serverTimeZone.timeZone;
